export default __webpack_public_path__ + "f834d52046b85081cde9626031fe00d6.png";